import { CardBrand } from "components/UI/molecules";
import "./index.scss";
import { useFormatBrandInfo } from "./utils/useFormatBrandInfo";

export const BrandsGrid = ({ brands = [] }) => {
  const { getInfoLabel } = useFormatBrandInfo();
  return brands.length ? (
    <main
      className="content-buy-gift-cards"
      data-testid="content-buy-gift-cards"
    >
      {brands.map((item, index) => (
        <CardBrand
          brandName={item.brand_name}
          image={item.circle_icon_url}
          linkTo={`/buy-${item.slug}-gift-cards`}
          info={getInfoLabel({
            cashBack: item.cash_back,
            savings: item.savings
          })}
          label={item.brand_name}
          key={index}
          customClassName="buy-brand"
        />
      ))}
    </main>
  ) : (
    <div className="no-results">
      <p>Sorry, we couldn't find any results. Please try a different search.</p>
    </div>
  );
};
